import {Pipe, PipeTransform, SecurityContext} from '@angular/core';
import {FormControl} from '@angular/forms';
import {DomSanitizer, SafeValue} from '@angular/platform-browser';
import DOMPurify from 'dompurify';

@Pipe({
	name: 'formControlSanitizer'
})
export class FormControlSanitizerPipe implements PipeTransform {
	constructor(private readonly domSanitizer: DomSanitizer) {
	}

	private bypassSecurityTrust(
		context: SecurityContext,
		purifiedValue: string,
	): SafeValue | null {
		switch (context) {
			case SecurityContext.HTML:
				const safeHtml = this.domSanitizer.bypassSecurityTrustHtml(purifiedValue);
				return this.domSanitizer.sanitize(SecurityContext.HTML, safeHtml);
			case SecurityContext.STYLE:
				const safeStyle = this.domSanitizer.bypassSecurityTrustStyle(purifiedValue);
				return this.domSanitizer.sanitize(SecurityContext.STYLE, safeStyle);
			case SecurityContext.SCRIPT:
				const safeScript = this.domSanitizer.bypassSecurityTrustScript(purifiedValue);
				return this.domSanitizer.sanitize(SecurityContext.SCRIPT, safeScript);
			case SecurityContext.URL:
				const safeUrl = this.domSanitizer.bypassSecurityTrustUrl(purifiedValue);
				return this.domSanitizer.sanitize(SecurityContext.URL, safeUrl);
			case SecurityContext.RESOURCE_URL:
				const safeResourceUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(purifiedValue);
				return this.domSanitizer.sanitize(SecurityContext.RESOURCE_URL, safeResourceUrl);
			default:
				return null;
		}
	}

	transform(
		control: FormControl,
		context: SecurityContext = SecurityContext.HTML
	): FormControl<SafeValue> | null {
		const controlValue = control.value;
		control.patchValue(this.bypassSecurityTrust(context, DOMPurify.sanitize(controlValue)));
		return control;
	}
}
